import { getFile } from '../../services/blockchain';
import { getHistoryRecords } from '../../services/sql/sqlHelpers';
import { handleReadFile } from '../fileHelpers';

export const addNotValidated = async (
  hash,
  setFiles,
  validationComplete,
  validateState,
  setValidationComplete,
) => {
  const fileInfo: any = await getFile(hash);
  const fileBlob = fileInfo.blob;

  if (fileInfo) {
    if (validationComplete && !validateState) {
      //Reset if files exist from completed validation
      setFiles([]);
    }

    setValidationComplete(false); // Set back to false to activate button

    const readFileData: any = await handleReadFile(fileBlob);

    const historyRecords = await getHistoryRecords();
    const historyRecord = historyRecords.rows.filter((item) => item.HASH === hash);

    const addedFile = new File([fileInfo.blob], fileInfo.name, {
      type: fileInfo.blob.type,
    });

    if (historyRecord[0].JSON_PROOF !== 'null') {
      const jsonContent = JSON.parse(historyRecord[0].JSON_PROOF);
      const jsonFileName = historyRecord[0].JSON_FILE_NAME;

      setFiles((prevFiles) => [
        ...prevFiles,
        {
          file: addedFile,
          jsonFileName,
          jsonContent,
          fileData: readFileData,
          fileHash: hash,
          validationMethod: 'timestamp',
          progress: 'Ready for submit',
          validated: false,
        },
      ]);
    } else {
      // Update files arrays with files that are already uploaded
      setFiles((prevFiles) => [
        ...prevFiles,
        {
          file: addedFile,
          fileData: readFileData,
          fileHash: hash,
          validationMethod: 'fullfile',
          progress: 'Ready for submit',
          validated: false,
        },
      ]);
    }
  }
};
